export default __webpack_public_path__ + "static/media/snlc-new.729a1f0c.webp";